import * as A from 'fp-ts/Array';
import * as S from 'fp-ts/string';

function uppercaseFirstLetter(str: string[]): string[];
function uppercaseFirstLetter(str: string): string;
function uppercaseFirstLetter(str?: string | string[]) {
  if (Array.isArray(str)) {
    return str.map(uppercaseFirstLetter);
  }
  return str ? str[0].toUpperCase() + str.slice(1) : str;
}

export const dedup = A.uniq(S.Eq);

export { uppercaseFirstLetter };
